import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import config from "../config";
function Contact() {
const[status,setStatus]=useState('');  
const [formData,setFormData]=useState({
  name:'',
  email:'',
  mobile:'',
  message:''
});
const handleChang=(e)=>{
setFormData((prevData)=>({
  ...prevData,[e.target.name]:e.target.value
}))};

const handleWhatsupSubmit=(e)=>{
  debugger
  const {name,email,mobile,message}=formData;
  if (!name||!email||!mobile||!message) {
    alert("Please fill all the fields");
    return;
  }
  const whatsAppMessage = `Hello, my name is ${name}. I would like to discuss: ${mobile}. My message is: ${message}. You can reach me at ${email}.`;
  const whatsAppUrl = `https://wa.me/+91-9910668717?text=${encodeURIComponent(whatsAppMessage)}`;
  window.open(whatsAppUrl, '_blank');
  e.preventDefault();

}

 const handleSubmit = async (e) => {
  debugger
    e.preventDefault();
    setStatus('Sending...');
    debugger
  const{name,email,mobile,message}=formData;
  let msg=`  Hi  ${name},
  <br/>
  Thanks for enquiry on our site ,Our team will contact you soon.
  <br/>
  <br/>
 <b> Your submitted Details: </b>
  <br/>
   Name: ${name} </b>Mobile: ${mobile}\nEmail: ${email}\nMessage: ${message}
  <br/>
  <br/>
 <h5> Thanks & Regards </h5>
  Sanjay Prasad & Associates (Chartered Accountant)
  <br/> 
  Mobile : +91-9910668717
  <br/>
  Email : contact@caspassociates.com ,
  caspassociates01@gmail.com
  <br/>
  website : https://caspassociates.com/
  <br/>
   Address : F-2/275, Shiv Durga Vihar, Lakkarpur, Surajkund
   Faridabad, Haryana-121009, INDIA.
   `
  
  let bodydata= {
    "toEmail": email,
    "subject": "Thanks for Enquiry on caspassociates.com ",
    "body": msg,
    "CC":"caspassociates01@gmail.com",
    "BCC":"softwebms@gmail.com"
}

const username = 'admin';
const password = '1234';

// Encode in base64
const token = btoa(`${username}:${password}`);

    try {
      const response = await axios.post(`${config.apiBaseURL}/Mail/sendmail`, bodydata, {
        headers: {
           'Authorization': `Basic ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 200) {
        //setStatus('Message sent successfully!');
        toast.success('Thanks! Your message has been sent.')
        setFormData({ name: '', email: '', mobile: '', message: '' });
      } else {
        setStatus('Failed to send message.');
        toast.error('Something went wrong. Please try again.');
      }
    } catch (error) {
     // console.error('Send mail error:', error);
     // setStatus('Error sending message.');
    }
  };


    return (
      <>
    
        <div className="page-title">
      <div className="container">
        <nav className="breadcrumbs">
          <ol>
            <li><a href="#">Home</a></li>
            <li className="current">Contact</li>
          </ol>
        </nav>
        <h1>Contact Us</h1>
      </div>
       </div>
 {/* Contact Section */}
 <section id="contact" className="contact section">
 <div className="container" data-aos="fade-up" data-aos-delay="100">

  <div className="row gy-4">

    <div className="col-lg-6">
      <div className="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="200">
        <i className="bi bi-geo-alt"></i>
        <h3>Address</h3>
        <p>F-2/275, Shiv Durga Vihar, Lakkarpur, Surajkund</p>
        <p>Faridabad, Haryana-121009</p>
      </div>
    </div>{/* End Info Item */}

    <div className="col-lg-3 col-md-6">
      <div className="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="300">
        <i className="bi bi-telephone"></i>
        <h3>Call Us</h3>
        <p>+91-9910668717</p>
      </div>
    </div>{/* End Info Item */}

    <div className="col-lg-3 col-md-6">
      <div className="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="400">
        <i className="bi bi-envelope"></i>
        <h3>Email Us</h3>
        <p>contact@caspassociates.com</p>
        <p>caspassociates01@gmail.com</p>
      </div>
    </div>{/* End Info Item */}

  </div>

  <div className="row gy-4 mt-1">
    <div className="col-lg-6" data-aos="fade-up" data-aos-delay="300">
    <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d112220.51563143496!2d77.2116455871712!3d28.482825662425824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x390ce72e38b2313b%3A0x226f4918b27c7f8c!2sf-2%2F275%2C%20Lakkarpur%2C%20Shiv%20Durga%20Vihar%2C%20Faridabad%2C%20Haryana%20121009!3m2!1d28.482858!2d77.2940234!5e0!3m2!1sen!2sin!4v1747591455052!5m2!1sen!2sin" width="100%" height="400" style={{border:"0px"}} allowFullScreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>    
    </div>

    <div className="col-lg-6">
      <form  onSubmit={handleSubmit} className="php-email-form" data-aos="fade-up" data-aos-delay="400">
        <div className="row gy-4">

          <div className="col-md-6">
            <input type="text" name="name" value={formData.name} onChange={handleChang} className="form-control" placeholder="Your Name" required/>
          </div>

          <div className="col-md-6 ">
                        <input type="text" name="mobile" value={formData.mobile} onChange={handleChang} className="form-control" placeholder="your number" required/>
          </div>

          <div className="col-md-12">
            <input type="email" className="form-control" value={formData.email} onChange={handleChang} name="email" placeholder="Your Email" required/>
          </div>

          <div className="col-md-12">
            <textarea className="form-control" value={formData.message} onChange={handleChang} name="message" rows="6" placeholder="Message" required></textarea>
          </div>

          <div className="col-md-12 text-center">
            <div className="loading">Loading</div>
            <div className="error-message"></div>
            <div className="sent-message">Your message has been sent. Thank you!</div>

            <button type="submit">Send Message</button> &nbsp;
            <button type="button" onClick={handleWhatsupSubmit} className="btn btn-primary">Send via WhatsApp</button>  
          </div>

        </div>
      </form>
    </div>{/* End Contact Form */}

  </div>

</div>  

</section>{/* /Contact Section */}

      </>
    );
  }   
  export default Contact;